import { useEffect, useState } from 'react';
import Builder from '@form-engine/builder-application';
import useSaveFormAction from '../../actions/save-form';
import useFormHistory from '../../hooks/use-form-history';

type HistoryState = ReturnType<typeof useFormHistory>['state'];

// loosely compares the histories by value, not by reference where possible
function isHistoryDirty(prev: HistoryState, current: HistoryState) {
    if (prev === current) return false;
    if (!prev || !current) return true;
    return JSON.stringify(prev) !== JSON.stringify(current);
}

export function useSaveOnViewUnload(currentView: string) {
    const [prevView, setPrevView] = useState(currentView);
    const [historyDirty, setHistoryDirty] = useState(false);
    const { state: history } = useFormHistory();
    const [prevHistory, setPrevHistory] = useState(history);
    const save = useSaveFormAction();

    useEffect(() => {
        if (isHistoryDirty(prevHistory, history)) {
            setHistoryDirty(true);
        }
    }, [history, setHistoryDirty, prevHistory, setPrevHistory]);

    useEffect(() => {
        if (prevView === currentView) return;

        // save if the prev view requires it and the form has changes, that
        // require saving it (everything thats tracked in history)
        if (
            historyDirty &&
            Builder.formStudioViews[prevView]?.shouldSaveOnUnload
        ) {
            setHistoryDirty(false);
            save();
        }

        setPrevView(currentView);
    }, [
        currentView,
        prevView,
        setPrevView,
        save,
        setHistoryDirty,
        historyDirty,
    ]);
}
